import { render, staticRenderFns } from "./img.vue?vue&type=template&id=401d3aad&scoped=true"
import script from "./img.vue?vue&type=script&lang=js"
export * from "./img.vue?vue&type=script&lang=js"
import style0 from "./img.vue?vue&type=style&index=0&id=401d3aad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401d3aad",
  null
  
)

export default component.exports